import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { News } from 'src/app/_models/news';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'app-newsroom',
  templateUrl: './newsroom.component.html',
  styleUrls: ['./newsroom.component.scss']
})
export class NewsroomComponent implements OnInit {
  newsRecent: News[];
  returnNewsRecent: News[];
  newsPressRelease: News[];
  returnNewsPress: News[];
  showBoundaryLinks: boolean = true;
   showDirectionLinks: boolean = true;
  constructor(private apiService: ApiService) { 
    
  }

  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.returnNewsRecent = this.newsRecent.slice(startItem, endItem);
 }
  pageChangedPress(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.returnNewsPress = this.newsPressRelease.slice(startItem, endItem);
  }

  ngOnInit() {
   
    this.apiService.getNews().subscribe(data => {
      console.log(data)

      this.newsRecent = data.filter(it => {
        if(it.newsCategoryId != 1 && it.active)
          return it
      })
      this.newsPressRelease = data.filter(it => {
        if(it.newsCategoryId == 1 && it.active)
          return it
      })
      this.returnNewsRecent = this.newsRecent.slice(0, 9);
      this.returnNewsPress = this.newsPressRelease.slice(0, 9);
      //Press Releases
    })

  }

}
